import { FC } from "react";
import { Chip, ChipProps } from "@mui/material";
import { MergeType } from "@mui/icons-material";
import { Colors } from "../../theme";

type Props = {
  size?: ChipProps["size"];
};

// Marks a counterparty or broker onboarded because of a merger. Orange, like the banner in the
// merger mails, so the two read as the same signal.
export const MergerChip: FC<Props> = ({ size = "small" }) => (
  <Chip
    size={size}
    icon={<MergeType sx={{ "&&": { color: "#FFF" } }} />}
    label="MERGER"
    sx={{
      backgroundColor: Colors.MFT_ORANGE,
      color: "#FFF",
      fontWeight: 600,
      flexShrink: 0
    }}
  />
);
